import { getParams } from './UrlManipulation'
import { deleteCookie, readCookie, storeCookie } from './LocalStorage'
import { AuthService } from '../services'
import { googleConfig, auth0Config } from './oauthConfig'

const GOOGLE = "google"
const AUTH0 = "auth0"
const AUTHCOOKIE = "authcookie"

const midnightToday = new Date()
midnightToday.setHours(24, 0, 0, 0)

const storeUser = (user) => {
    if (user) {
        const expiryDate = new Date()
        expiryDate.setTime(expiryDate.getTime() + (user.expires_in || user.expires) * 1000)
        const json = JSON.stringify(user)
        const b64 = btoa(json)
        storeCookie(AUTHCOOKIE, b64, expiryDate)
    } else {
        deleteCookie(AUTHCOOKIE)
    }
}

const readUser = () => {
    const b64 = readCookie(AUTHCOOKIE)
    if (!b64) return null
    const json = atob(b64)
    const user = JSON.parse(json)
    return user
}

class UserSubject {
    constructor() {
        this.observers = []
    }

    attach(callback) {
        this.observers.push(callback)
    }

    detach(callback) {
        this.observers = this.observers.filter(observer => observer !== callback)
    }

    notify(userData) {
        setTimeout(() => {
            this.observers.forEach(callback => callback(userData))
        }, 100)
    }

    update(userData) {
        storeUser(userData)
        this.notify(userData)
    }

    getUser() {
        const user = readUser()
        if (!user) return null
        else return { ...user }
    }
}

const userSubject = new UserSubject()

const parseRedirectToken = (providerType, redirectUri) => {
    const params = getParams()
    if ("code" in params && !window.location.pathname.includes("error")) {
        return AuthService.getAccessToken(params.code, providerType, redirectUri)
            .then(userData => {
                userSubject.update(userData)
            })
    }
}

const createAuthUrl = (config) => {
    const baseUrl = config.authorizationUri
    const params = {
        client_id: config.clientId,
        redirect_uri: config.redirectUri,
        response_type: "code",
        scope: config.scopes.join(" ")
    }
    const paramString = Object.keys(params).map(key => `${key}=${params[key]}`).join("&")
    return `${baseUrl}?${paramString}`
}

const startLoginFlow = (providerType) => {
    let url
    if (providerType === GOOGLE) {
        url = createAuthUrl(googleConfig)
    } else if (providerType === AUTH0) {
        url = createAuthUrl(auth0Config)
    }
    window.open(url, "_self")
}

const logOut = () => {
    userSubject.update(null)
}


const getUserInfo = () => {
    const user = userSubject.getUser()
    if (!user) return new Promise(resolve => resolve(null))
    let url
    if (user.provider === AUTH0) url = auth0Config.userInfoUri
    else if (user.provider === GOOGLE) url = googleConfig.userInfoUri
    return fetch(url, {
        method: 'GET',
        headers: createAuthHeaders()
    })
        .then(async response => {
            return await response.json()
        })
        .catch(error => {
            throw error
        })
}

const createAuthHeaders = () => {
    const user = userSubject.getUser()
    if (!user) return {}
    else return {
        'Authorization': `Bearer ${user.access_token}`,
    }
}

export { createAuthHeaders, getUserInfo, parseRedirectToken, logOut, startLoginFlow, readUser, storeUser, userSubject, AUTH0, GOOGLE }